import { combineReducers } from "redux";
import coupon from "../features/admin/couponmanagement/coupon/Slice";
import subscription from "../features/admin/couponmanagement/subscription/Slice";
import usersubscription from "../features/admin/couponmanagement/usersubscription/Slice";


const couponmanagement = combineReducers({
  coupon: coupon,
  subscription: subscription,
  usersubscription: usersubscription,
});

export default couponmanagement;
